export const GET_CITY = 'GET_CITY'
export const GET_CITY_SUCCESS = 'GET_CITY_SUCCESS'

export const GET_DISTRICT_FROM_CITY = 'GET_DISTRICT_FROM_CITY'
export const GET_DISTRICT_FROM_CITY_SUCCESS = 'GET_DISTRICT_FROM_CITY_SUCCESS'

export const GET_LOCATION = 'GET_LOCATION'
export const GET_LOCATION_SUCCESS = 'GET_LOCATION_SUCCESS'

export const UPDATE_CITY_ID = 'UPDATE_CITY_ID'
export const UPDATE_CITY_ID_SUCCESS = 'UPDATE_CITY_ID_SUCCESS'

export const UPDATE_DISTRICT_ID = 'UPDATE_DISTRICT_ID'
export const UPDATE_DISTRICT_ID_SUCCESS = 'UPDATE_DISTRICT_ID_SUCCESS'

export const APIC_GetWardByDistrict = 'APIC_GetWardByDistrict'
export const APIC_GetWardByDistrict_SUCCESS = 'APIC_GetWardByDistrict_SUCCESS'

export const UPDATE_WARD_ID = 'UPDATE_WARD_ID'
export const UPDATE_WARD_ID_SUCCESS = 'UPDATE_WARD_ID_SUCCESS'
